import { format, parseISO, compareAsc } from "date-fns";
import { Button } from "@rumbledirect/ui";
import { Flex, Popconfirm, TableColumnsType } from "antd";
import { Concept } from "@rumble-it/common-lib/types/models/Concept.interface";
import { NavLink } from "react-router-dom";
import { DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import { UseMutationResult } from "@tanstack/react-query";

export const conceptColumns = (
  deleteConceptMutation: UseMutationResult<Concept, Error, string, unknown>,
): TableColumnsType<Concept> => [
  {
    title: "Referentie",
    dataIndex: "label",
    key: "label",
    render: (_: any, record) => (
      <>
        <NavLink to={`/dealer-intake?conceptId=${record.id}`}>
          {record.label}
        </NavLink>
      </>
    ),
  },
  {
    title: "Datum aangemaakt",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (_: any, record) =>
      format(parseISO(record.createdAt), "dd-MM-yyyy HH:mm"),
    sorter: (a, b) => compareAsc(parseISO(a.createdAt), parseISO(b.createdAt)),
  },
  {
    title: "Acties",
    key: "actions",
    render: (_: any, record) => (
      <Flex gap="8px">
        <Button
          href={`/dealer-intake?conceptId=${record.id}`}
          icon={<EyeOutlined />}
          variant="light"
        />
        <Popconfirm
          title="Weet je zeker dat je dit concept wilt verwijderen?"
          onConfirm={() => deleteConceptMutation.mutate(record.id)}
          okText="Ja"
          cancelText="Nee"
        >
          <Button danger icon={<DeleteOutlined />} />
        </Popconfirm>
      </Flex>
    ),
  },
];
